export default "__VITE_ASSET__zvKewJoz__"